/* eslint-disable no-console */
/**
 * A logger, very simple for now but might one day have a lot of the features of the VizClient console logger
 * https://mytableau.tableaucorp.com/display/devcomm/VizClient+Console+Logging
 * or maybe be useful for actually collecting logs and sending them somewhere
 * Initial goal: wrap all console.log calls and make them mockable them for tests
 */

/* tslint:disable:no-console*/
class Log implements Tableau.LoggerInterface {

  private isRunningTests = window.hasOwnProperty('mocha'); // always show console output during tests

  private currentlyLogging: boolean;
  private allowLogging(): boolean {
    // todo: also add a check for the debug flag in the url?
    // You can enable logging by setting window.TableauToConsole = true in the console
    return this.currentlyLogging || this.isRunningTests || (window as any).TableauToConsole;
  }

  private output: any;

  private fakeConsole: any = {
     info:  (message: string) => {},
     warn:  (message: string) => {},
     log: (message: string) => {},
     error: (message: string | Error) => {},
  };

  constructor() {
    // IE9 (real, not emulated) does not even have a console object without the Dev Tools open.
    if (!window.console) { (window as any).console = {}; }
    this.output = console.log ? window.console : this.fakeConsole;
    this.currentlyLogging = false; // defaults to off for production
  }

  public info(message: string){
    if (this.allowLogging()) {
      this.output.info(message);
    }
  }

  public warn(message: string){
    if (this.allowLogging()) {
      this.output.warn(message);
    }
  }

  public log(message: string){
    if (this.allowLogging()) {
      this.output.log(message);
    }
  }

  public error(message: string | Error){
    // always save error messages
    this.saveToLocalStorage(message);
    if (this.allowLogging()){
      this.output.error(message);
    }
  }

  public object(item: Object){
    if (this.allowLogging()) {
      if (window.console && console.log) {
        console.log(item);
      }
      else {
        this.output.info('OBJECT:');
      }
    }
  }

  private saveToLocalStorage(message: string | Error){
    if (!localStorage) return; // embedded desktop login page is on ancient qtweb engine
    // naive implementation, limit log messages to 60 by using the current minute as the key
    // DO NOT write our own proper implementation. Use an existing library.
    const now = new Date();
    const keyIndex = now.getMinutes();
    const key = 'TableauLog' + keyIndex;
    const logMessage = '(' + now.getTime() + ') ' +  message;
    localStorage.setItem(key, logMessage);
  }

}

const staticLogger: Log = new Log();

export namespace Tableau {

  export interface LoggerInterface {
    info(message: string): void;
    warn(message: string): void;
    log(message: string): void;
    error(message: string): void;
    error(error: Error): void;
    object(item: Object): void; // use for logging an actual object to the console
  }

  export function Logger(): LoggerInterface {
   return staticLogger;
  }
}
